import { render } from "./DriverStatusApiAccess.vue?vue&type=template&id=46c03147&scoped=true&ts=true"
import script from "./DriverStatusApiAccess.vue?vue&type=script&lang=ts"
export * from "./DriverStatusApiAccess.vue?vue&type=script&lang=ts"

import "./DriverStatusApiAccess.vue?vue&type=style&index=0&id=46c03147&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c03147"]])

export default __exports__